import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  OPEN_RESPONSE_MODALL_PROJECT_CODE,
  SET_KEYWORD_SEARCHL_PROJECT_CODE,
  PROJECT_CODE_NON_SERVICE_GET_REQUEST,
  PROJECT_CODE_NON_SERVICE_GET_SUCCESS,
  PROJECT_CODE_NON_SERVICE_GET_FAILURE,
  PROJECT_CODE_NON_SERVICE_GET_RESET,
  PROJECT_CODE_NON_SERVICE_EDIT_REQUEST,
  PROJECT_CODE_NON_SERVICE_EDIT_SUCCESS,
  PROJECT_CODE_NON_SERVICE_EDIT_FAILURE,
  PROJECT_CODE_NON_SERVICE_EDIT_RESET,
} from './types'

export function getProjectNonService(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/projects/non-services/${id}`,
      method: 'GET',
      types: [
        PROJECT_CODE_NON_SERVICE_GET_REQUEST,
        PROJECT_CODE_NON_SERVICE_GET_SUCCESS,
        PROJECT_CODE_NON_SERVICE_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editProjectNonService(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/projects/non-service/${id}`,
      method: 'PUT',
      types: [
        PROJECT_CODE_NON_SERVICE_EDIT_REQUEST,
        PROJECT_CODE_NON_SERVICE_EDIT_SUCCESS,
        PROJECT_CODE_NON_SERVICE_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function resetGetProjectNonService() {
  return {
    type: PROJECT_CODE_NON_SERVICE_GET_RESET,
  }
}

export function resetEditProjectNonService() {
  return {
    type: PROJECT_CODE_NON_SERVICE_EDIT_RESET,
  }
}

export function openResponseModal(payload) {
  return {
    type: OPEN_RESPONSE_MODALL_PROJECT_CODE,
    payload,
  }
}

export function setKeywordSearch(payload) {
  return {
    type: SET_KEYWORD_SEARCHL_PROJECT_CODE,
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/actions/project-code/project-code.js